"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeckInformationSchema = void 0;
const zod_1 = require("zod");
// Schema used to list decks from server
const DeckInformationSchema = zod_1.z.object({
    name: zod_1.z.string(),
    animatorId: zod_1.z.string(),
    animatorName: zod_1.z.string(),
    cardsCount: zod_1.z.number(),
    isDefault: zod_1.z.boolean(),
    deckId: zod_1.z.number(),
});
exports.DeckInformationSchema = DeckInformationSchema;
